/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IntegrationState {
  isMsiIntegrated: boolean;
  isGuestPassIntegrated: boolean;
  isTokenValid: boolean;
  loading: boolean;
  error: string | null;
}

const initialState: IntegrationState = {
  isMsiIntegrated: false,
  isGuestPassIntegrated: false,
  isTokenValid: false,
  loading: false,
  error: null,
};

const integrationSlice = createSlice({
  name: 'integration',
  initialState,
  reducers: {
    fetchIntegrationStatus(state, _action: PayloadAction<{ orgId: number }>) {
      state.loading = true;
      state.error = null;
    },

    setIntegrationStatus(
      state,
      action: PayloadAction<Omit<IntegrationState, 'loading' | 'error'>>,
    ) {
      state.isMsiIntegrated = action.payload.isMsiIntegrated;
      state.isGuestPassIntegrated = action.payload.isGuestPassIntegrated;
      state.isTokenValid = action.payload.isTokenValid;
      state.loading = false;
    },

    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    clearIntegrationState() {
      return initialState;
    },
  },
});

export const {
  fetchIntegrationStatus,
  setIntegrationStatus,
  setError,
  setLoading,
  clearIntegrationState,
} = integrationSlice.actions;

export const integrationActions = integrationSlice.actions;
export default integrationSlice.reducer;
